import { render, staticRenderFns } from "./ProductionReport.vue?vue&type=template&id=54be742e&"
import script from "./ProductionReport.vue?vue&type=script&lang=js&"
export * from "./ProductionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductionReport.vue"
export default component.exports